import clsx from "clsx";

export const Card = ({ children, className, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={clsx("bg-[#FFFFFF] rounded-[10px] p-4", className)}
    >
      {children}
    </div>
  );
};
